import { useEffect } from 'react';

const GoogleAnalytics = ({ measurementId }) => {
  useEffect(() => {
    if (import.meta.env.VITE_APP_ENV === 'production') {
      const gtagScript = document.createElement('script');
      gtagScript.async = true;
      gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;

      const inlineScript = document.createElement('script');
      inlineScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${measurementId}');
      `;

      document.head.appendChild(gtagScript);
      document.head.appendChild(inlineScript);
    }

    return () => {
      if (import.meta.env.VITE_APP_ENV === 'production') {
        const scripts = document.head.querySelectorAll(
          `script[src*="googletagmanager.com"]`,
        );
        scripts.forEach(script => script.remove());
      }
    };
  }, [measurementId]);

  return null;
};

export default GoogleAnalytics;
